import { useEffect, useState } from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";

export const SearchableDropdown = ({
  className,
  id,
  label,
  value,
  dropdownValues = [],
  handleDropdownChange,
  defaultPhrase = "Select One",
  multiple = false,
  compact = false,
  creatable = false,
  createdLabel = null,
}) => {
  const [localOptions, setLocalOptions] = useState([]);
  const SelectComponent = creatable ? CreatableSelect : Select;

  useEffect(() => {
    setLocalOptions((prev) => {
      const baseOptions = dropdownValues.map((d) => ({
        value: d.key,
        label: d.label,
        isNew: false,
      }));

      const newOptions = prev.filter((option) => option.isNew);

      return [...baseOptions, ...newOptions];
    });
  }, [dropdownValues]);

  const selectedOption = multiple
    ? localOptions.filter((option) =>
        value?.some?.((selectedValue) =>
          selectedValue?.value
            ? selectedValue.value === option.value
            : selectedValue === option.value
        )
      )
    : value?.value
      ? localOptions.find((option) => option.value === value.value) || value
      : localOptions.find((option) => option.value === value) || null;

  const handleCreateOption = (inputValue) => {
    const newOption = {
      value: `__new__${id}__${inputValue}`,
      label: inputValue,
      isNew: true,
    };

    setLocalOptions((prev) => [
      ...prev.filter((x) => !x.isNew),
      newOption,
    ]);

    handleDropdownChange({
      target: {
        id,
        value: newOption.value,
        selectedOption: newOption,
        createdLabel: inputValue,
      },
    });
  };

  const onChange = (selected) => {
    const nextValue = multiple
      ? selected?.map((option) => option.value) ?? []
      : selected
        ? selected.value
        : "";

    handleDropdownChange({
      target: {
        id,
        value: nextValue,
        selectedOption: selected,
        createdLabel: selected?.isNew ? selected.label : null,
      },
    });
  };

  const MultiSelectOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          readOnly
          style={{ marginRight: "10px" }}
        />

        {props.label}
      </components.Option>
    );
  };

  return (
    <div className={className}>
      {label && <label htmlFor={id}>{label}</label>}

      <SelectComponent
        inputId={id}
        classNamePrefix="dropdown"
        options={localOptions}
        value={selectedOption}
        onChange={onChange}
        onCreateOption={creatable ? handleCreateOption : undefined}
        placeholder={defaultPhrase}
        isSearchable
        isMulti={multiple}
        closeMenuOnSelect={!multiple}
        hideSelectedOptions={false}
        controlShouldRenderValue={!compact}
        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
        getOptionValue={(option) => String(option.value)}
        getOptionLabel={(option) => option.label}
        components={
          multiple
            ? {
                Option: MultiSelectOption
              }
            : undefined
        }
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 999999,
          }),
        }}
      />
    </div>
  );
};